import Vue from 'vue';
import Vuex from 'vuex';
import aliOSS from './aliyunOSS/aliyunSTSN'
import question from './question/question'
import request from './request/index'

Vue.use(Vuex);

const state = {
    user: {
        isLogin: JSON.parse(window.sessionStorage.getItem('isLogin')) || false,
        username: JSON.parse(window.sessionStorage.getItem('username')) || '',
        userid: JSON.parse(window.sessionStorage.getItem('userid')) || '',
        isCallOnly: JSON.parse(window.sessionStorage.getItem('userid')) || '',
    },

    callObj: {
        customerServiceCode: JSON.parse(window.sessionStorage.getItem('customerServiceCode')) || -1,
        customerServiceCodeValue: JSON.parse(window.sessionStorage.getItem('customerServiceCodeValue')) || '未注册'
    },
    patient: {
        patientId: JSON.parse(window.sessionStorage.getItem('patientId')) || null
    },
    currentPage: window.sessionStorage.getItem('currentPage') || null,
    questionId: window.sessionStorage.getItem('questionId') || null, // task id 为进入 任务列表后 的 id
    taskId: JSON.parse(window.sessionStorage.getItem('taskId')) || null, // task id 为进入 任务列表后 的 id
    taskCenterId: JSON.parse(window.sessionStorage.getItem('taskCenterId')) || null, // task id 为进入 任务列表后 的 id
    taskTitle: JSON.parse(window.sessionStorage.getItem('taskTitle')) || null, // task id 为进入 任务列表后 的 id
    nextCallNumber: JSON.parse(window.sessionStorage.getItem('nextCallNumber')) || null,// 下一个拨打的号码
    nextCallNumberId: JSON.parse(window.sessionStorage.getItem('nextCallNumberId')) || null, // 下一个拨打号码的Id
    follupTime: JSON.parse(window.sessionStorage.getItem('follupTime')) || null,  // 本次随访时间
    contactId: JSON.parse(window.sessionStorage.getItem('contactId')) || null, // 录音ID
    contactSuccessIds: JSON.parse(window.sessionStorage.getItem('contactSuccessIds')) || "", // 录音ID
    taskType: JSON.parse(window.sessionStorage.getItem('taskType')) || null,  // 随访类型   1. 随访 , 2.通知 , 3. 回访
    currentCallNumber: JSON.parse(window.sessionStorage.getItem('currentCallNumber')) || null,  // 当前打完电话的号码
    currentCallNumberId: JSON.parse(window.sessionStorage.getItem('currentCallNumberId')) || null, // 当前打完电话的号码Id
    follupTimeString: JSON.parse(window.sessionStorage.getItem('follupTimeString')) || null, // 本次随访时间 string 类型
    isCalling: JSON.parse(window.sessionStorage.getItem('isCalling')) || false,
    workBenchCallStatus: JSON.parse(window.sessionStorage.getItem('isCalling')) || null,
    callingNumber: window.sessionStorage.getItem('callingNumber') || 'auto', //设置主叫号码
}
const getters = {
    isLogin: (state) => {
        return state.user.isLogin || false
    },
    username: (state) => {
        return state.user.username || ''
    },
    userid: (state) => {
        return state.user.userid || ''
    },
    questionId: (state) => {
        return state.questionId || ''
    },
    currentPage: (state) => {
        return state.currentPage || ''
    },
    isCallOnly: () => {
        return state.user.isCallOnly || false
    },
    patientId: (state) => {
        return state.patient.patientId || ''
    },
    workBenchCallStatus: (state) => {
        return state.workBenchCallStatus || null
    },
    taskValue: (state) => {
        // 电话回访
        if (state.taskType === 3) {
            return 'PatientVisitAgain'
        } else if (state.taskType === 2) {
            // 电话通知
            return 'PatientNotify'
        } else if (state.taskType === 1) {
            // 随访
            return 'PatientInfo'
        }
    },
    phoneStatus: (state) => {
        // 电话回访
        return state.isCalling || false;
    },
    getTaskCenterId: (state) => {
        // 电话回访
        return state.taskCenterId || "";
    },
    getCallingNumber: (state) => {
        return state.callingNumber || 'auto'
    },
    taskTitle: (state) => {
        return state.taskTitle || ""
    },
}
const mutations = {
    login(state, userinfo) {
        console.log('-------  ------------------------ ', userinfo)
        state.user.isLogin = true;
        window.sessionStorage.setItem('isLogin', JSON.stringify(true))
        state.user.username = userinfo.username;
        window.sessionStorage.setItem('username', JSON.stringify(userinfo.username));
        state.user.userid = userinfo.userid;
        window.sessionStorage.setItem('userid', JSON.stringify(userinfo.userid));
        state.user.isCallOnly = userinfo.isCallOnly;
        window.sessionStorage.setItem('isCallOnly', JSON.stringify(userinfo.isCallOnly));
    },
    logout(state) {
        state.user.isLogin = false;
        state.user.username = '';
        state.user.userid = '';
        state.callObj.customerServiceCode = -1;
        state.callObj.customerServiceCodeValue = '未注册';
        state.patient.patientId = null;
        state.taskId = null;
        state.taskCenterId = null;
        state.taskTitle = null;
        state.isCalling = false;
        window.sessionStorage.removeItem('isLogin');
        window.sessionStorage.removeItem('workBenchCallStatus');
        window.sessionStorage.removeItem('username');
        window.sessionStorage.removeItem('userid');
        window.sessionStorage.removeItem('customerServiceCode');
        window.sessionStorage.removeItem('customerServiceCodeValue');
        window.sessionStorage.removeItem('patientId');
        window.sessionStorage.removeItem('taskId');
        window.sessionStorage.removeItem('taskCenterId');
        window.sessionStorage.removeItem('taskTitle');
        window.sessionStorage.removeItem('isCalling');
        window.sessionStorage.removeItem('callingNumber');
    },
    resetPatient(state) {
        // 患者
        state.patient.patientId = null;
        state.nextCallNumber = null;
        state.nextCallNumberId = null;
        state.currentCallNumber = null;
        state.currentCallNumberId = null;
        state.follupTimeString = null;
        state.follupTime = null;
        state.isCalling = false;
        state.contactId = null;
        state.contactSuccessIds = "";
        window.sessionStorage.removeItem('patientId');
        window.sessionStorage.removeItem('nextCallNumber');
        window.sessionStorage.removeItem('nextCallNumberId');
        window.sessionStorage.removeItem('currentCallNumber');
        window.sessionStorage.removeItem('currentCallNumberId');
        window.sessionStorage.removeItem('follupTimeString');
        window.sessionStorage.removeItem('follupTime');
        window.sessionStorage.removeItem('isCalling');
        window.sessionStorage.removeItem('contactId');
        window.sessionStorage.removeItem('contactSuccessIds');
    },
    resetCallBackPatient() {
        state.patient.patientId = null;
        state.nextCallNumber = null;
        state.nextCallNumberId = null;
        state.currentCallNumber = null;
        state.currentCallNumberId = null;
        state.follupTimeString = null;
        state.follupTime = null;
        state.isCalling = false;

        window.sessionStorage.removeItem('patientId');
        window.sessionStorage.removeItem('nextCallNumber');
        window.sessionStorage.removeItem('nextCallNumberId');
        window.sessionStorage.removeItem('currentCallNumber');
        window.sessionStorage.removeItem('currentCallNumberId');
        window.sessionStorage.removeItem('follupTimeString');
        window.sessionStorage.removeItem('follupTime');
        window.sessionStorage.removeItem('isCalling');
    },
    callEvent(state, callEvent) {
        state.callObj.customerServiceCode = callEvent.callCode;
        window.sessionStorage.setItem('customerServiceCode', JSON.stringify(callEvent.callCode || -1));
        state.callObj.customerServiceCodeValue = callEvent.callCodeValue;
        window.sessionStorage.setItem('customerServiceCodeValue', JSON.stringify(callEvent.callCodeValue || ''));
    },
    setcurrentPatient(state, patient) {
        state.patient.patientId = patient.patientId || null;
        window.sessionStorage.setItem('patientId', JSON.stringify(state.patient.patientId))
    },
    setCurrentTaskId(state, taskId) {
        state.taskId = taskId || null;
        window.sessionStorage.setItem('taskId', JSON.stringify(state.taskId))
    },
    // 设置下一个 拨打电话的号码
    setNextCallNumber(state, callNumber) {
        state.nextCallNumber = callNumber.nextCallNumber || null;
        state.nextCallNumberId = callNumber.nextCallNumberId || null;
        window.sessionStorage.setItem('nextCallNumber', JSON.stringify(state.nextCallNumber))
        window.sessionStorage.setItem('nextCallNumberId', JSON.stringify(state.nextCallNumberId))
    },
    setTaskType(state, taskType) {
        state.taskType = taskType || null;
        window.sessionStorage.setItem('taskType', JSON.stringify(state.taskType))
    },
    setTaskCenterId(state, taskCenterId) {
        state.taskCenterId = taskCenterId || null;
        window.sessionStorage.setItem('taskCenterId', JSON.stringify(state.taskCenterId))
    },
    setTaskTitle(state, taskTitle) {
        state.taskTitle = taskTitle || null;
        window.sessionStorage.setItem('taskTitle', JSON.stringify(state.taskTitle))
    },
    setCurrentCallNumber(state, callNumber) {
        state.currentCallNumber = callNumber.currentCallNumber || null;
        state.currentCallNumberId = callNumber.currentCallNumberId || null;
        window.sessionStorage.setItem('currentCallNumber', JSON.stringify(state.currentCallNumber));
        window.sessionStorage.setItem('currentCallNumberId', JSON.stringify(state.currentCallNumberId))
    },
    // 随访时间
    setFollowupTime(state, follupTime) {
        //格式是 {
        //  yearSelect:'',
        //  monthSelect:'',
        //  daySelect:''
        // }
        state.follupTime = follupTime || null;
        window.sessionStorage.setItem('followupTime', JSON.stringify(state.follupTime))

        state.follupTimeString = (state.follupTime.yearSelect || '') + '/' + (state.follupTime.monthSelect || '') + '/' + (state.follupTime.daySelect || '');
        window.sessionStorage.setItem('follupTimeString', JSON.stringify(state.follupTimeString));
    },
    // 获取 随访 日期 string
    setStringWithFollupTime(state) {
        if (state.follupTime) {
            state.follupTime = state.follupTime || {}; // 如果为空的话
            state.follupTimeString = (state.follupTime.yearSelect || '') + '/' + (state.follupTime.monthSelect || '') + '/' + (state.follupTime.daySelect || '');
        } else {
            state.follupTimeString = null;
        }
        window.sessionStorage.setItem('follupTimeString', JSON.stringify(state.follupTimeString));
        return state.follupTimeString;
    },
    // TODO 可以设置 followup time string
    // 设置  随访 日期 string
    setFollowupTimeString(state, follupTimeString) {
        // string , 初始化 有值
        let obj = {};
        if (follupTimeString) {
            let dateArr = follupTimeString.split('/') || [];
            obj.yearSelect = dateArr[0] || '';
            obj.monthSelect = dateArr[1] || '';
            obj.daySelect = dateArr[2] || '';
        } else {
            obj = null;
        }
        //格式是 followupTimeString  为 '2019/04/17'
        //格式是 followupTime {
        //  yearSelect:'2019',
        //  monthSelect:'04',
        //  daySelect:'17'
        // }
        // 设置 string
        state.follupTimeString = follupTimeString;
        window.sessionStorage.setItem('follupTimeString', JSON.stringify(follupTimeString));
        // 设置
        state.follupTime = obj || null;
        window.sessionStorage.setItem('followupTime', JSON.stringify(state.follupTime));
    },
    // 是否正在通话中
    setCurrentCalling(state, calling) {
        state.isCalling = calling || null;
        window.sessionStorage.setItem('isCalling', JSON.stringify(state.isCalling));
    },
    // 保存录音ID --  通过去电的回调获取到
    setContactId(state, contactId) {
        state.contactId = contactId || null;
        window.sessionStorage.setItem('contactId', JSON.stringify(state.contactId))
    },
    setContactSuccessIds(state, contactId) {
        if (!state.contactSuccessIds) {
            state.contactSuccessIds = contactId || null;
        } else {
            state.contactSuccessIds = state.contactSuccessIds + ',' + contactId || null;
        }
        window.sessionStorage.setItem('contactSuccessIds', JSON.stringify(state.contactSuccessIds))
    },
    // 移除录音ID
    removeContactId(state) {
        state.contactId = null;
        window.sessionStorage.removeItem('contactId');
    },
    // 移除录音ID
    removeContactIds(state) {
        state.contactSuccessIds = "";
        window.sessionStorage.removeItem('contactSuccessIds');
    },
    //设置主叫号码
    setCallingNumber(state, callingNumber) {
        state.callingNumber = callingNumber;
        window.sessionStorage.setItem('callingNumber', callingNumber)
    },
    setQuestion(state, questionId) {
        state.questionId = questionId
        window.sessionStorage.setItem('questionId', questionId)
    },
    setCurrentPage(state, currentPage) {
        console.log('currentPageVX',currentPage);
        state.currentPage = currentPage
        window.sessionStorage.setItem('currentPage', currentPage)
    },
    setWorkBenchCallStatus(state, status) {
        state.workBenchCallStatus = status
        window.sessionStorage.setItem('workBenchCallStatus', status)
    }
}
const actions = {}


export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        aliOSS,
        question,
        request
    }
});
